The description type.
